import { render, staticRenderFns } from "./popup_leaderboard.vue?vue&type=template&id=0e4fef5e&"
import script from "./popup_leaderboard.vue?vue&type=script&lang=js&"
export * from "./popup_leaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LeaderboardGroup: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/leaderboard_group.vue').default,LeaderboardPrizes: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/leaderboard_prizes.vue').default})
